import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { Avatar, Box, Paper, Stack, Typography } from "@mui/material";

interface Props {
  label: string;
  iconColor: string;
  phoneNumber: string;
  trailingNode: React.ReactNode;
}

export function PhoneCard(props: Props) {
  const { label, iconColor, phoneNumber, trailingNode } = props;

  return (
    <Paper variant="outlined" sx={{ p: 1.5, maxWidth: 340 }}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Avatar
          sx={{
            width: 32,
            height: 32,
            bgcolor: `${iconColor}14`,
            color: iconColor,
          }}
        >
          <PhoneAndroidIcon sx={{ fontSize: 18 }} />
        </Avatar>
        <Box flex={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            textTransform="uppercase"
            letterSpacing={0.5}
          >
            {label}
          </Typography>
          <Typography variant="body2" fontFamily="monospace">
            {phoneNumber}
          </Typography>
        </Box>
        {trailingNode}
      </Stack>
    </Paper>
  );
}
